import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';

import './GoogleMap.css';

import { mapStyles } from './mapStyles';

class MarkerBrasserie extends Component {
  constructor() {
    super();
    this.displayInfosStore = this.displayInfosStore.bind(this);
    this.storeInfoRef = React.createRef();
  }
  displayInfosStore = () => {
    const currentStoreContent = this.storeInfoRef.current;
    if (currentStoreContent.style.display !== 'block') {
      currentStoreContent.style.display = 'block';
    } else {
      currentStoreContent.style.display = 'none';
    }
  };

  render() {
    return (
      <div className="marker-store-wrapper">
        <div
          className="marker-store-content content-brasserie"
          ref={this.storeInfoRef}
        >
          <p className="brasserie-content">
            Brasserie du baigneur
            <br />
            <span>8 passage de Provins, 74000 Annecy</span>
          </p>
        </div>
        <div className="marker-brasserie" onClick={this.displayInfosStore} />
      </div>
    );
  }
}

class MarkerStore extends Component {
  constructor() {
    super();
    this.displayInfosStore = this.displayInfosStore.bind(this);
    this.storeInfoRef = React.createRef();
  }
  displayInfosStore = () => {
    const currentStoreContent = this.storeInfoRef.current;
    if (currentStoreContent.style.display !== 'block') {
      currentStoreContent.style.display = 'block';
    } else {
      currentStoreContent.style.display = 'none';
    }
  };

  render() {
    const { nom, adresse } = this.props;
    return (
      <div className="marker-store-wrapper">
        <div className="marker-store-content" ref={this.storeInfoRef}>
          <span>{nom}</span>
          <br />
          {adresse}
        </div>
        <div className="marker-store" onClick={this.displayInfosStore} />
      </div>
    );
  }
}

const mapCenter = {
  lat: 45.910335,
  lng: 6.129048,
};

class GoogleMap extends Component {
  static defaultProps = {
    center: mapCenter,
    zoom: 13,
  };

  state = {
    stores: [],
  };

  componentDidMount() {
    const dataStore =
      'http://brasseriedubaigneur.com/wp-json/wp/v2/point_de_vente?_embed&per_page=100';
    fetch(dataStore)
      .then(res => res.json())
      .then(res => {
        this.setState({
          stores: res,
        });
      });
  }

  render() {
    const style = { height: 'calc(100vh - 160px)', width: '100%' };
    return (
      // Important! Always set the container height explicitly
      <div style={style}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyAbaWjjt049dAzhGeBzLir_C6BUv9og1lM' }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
          options={{ styles: mapStyles }}
        >
          <MarkerBrasserie lat={45.9219974} lng={6.125021400000037} />
          {this.state.stores.map(store => (
            <MarkerStore
              lat={store.acf.latitude}
              lng={store.acf.longitude}
              key={store.acf.adresse}
              nom={store.acf.nom}
              adresse={store.acf.adresse}
            />
          ))}
        </GoogleMapReact>
      </div>
    );
  }
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/Components/GoogleMap/GoogleMap.js